function checkBuilderMode(pathname: string): boolean {
  const builderRegex = /\/builder\/[^/]+$/;
  return builderRegex.test(pathname);
}

export default checkBuilderMode;
